export default __webpack_public_path__ + "static/media/scissors-01-new.b3bc102c.png";